'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'arrows-to-dotted-line';
var width = 384;
var height = 512;
var aliases = [];
var unicode = 'e0a6';
var svgPathData = 'M281 97l-72 72c-9.4 9.4-24.6 9.4-33.9 0L103 97c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l31 31 0-102.1c0-13.3 10.7-24 24-24s24 10.7 24 24l0 102.1 31-31c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM32 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm106.7 0a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm138.7-32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM352 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM103 415l72-72c9.4-9.4 24.6-9.4 33.9 0l72 72c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-31-31 0 102.1c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-102.1-31 31c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faArrowsToDottedLine = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;